<template>
  <div>
    <div class="c-location-modal">
      <aha-modal
        id="ahaTimeoutModal"
        ref="ahaTimeoutModal"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        hide-header-close
        hide-footer
        centered
        lazy
      >
        <b-container fluid>
          <div class="c-listing-header c-listing-header--medium pt-0">
            <div class="c-listing-header__cta-container d-block">
              <h2 class="c-listing-header__heading">{{translations.heading}}</h2>
            </div>
          </div>
          <p class="c-listing-header__subheading">{{translations.subheading}}</p>
          <br />
          <div>
            <form action="#" method="post" v-on:submit.prevent="onSubmit">
              <input type="submit" :value="translations.btnyeslabel" class="btn btn-primary btn-round" />
              <button @click.prevent="onCancel" class="btn btn-primary btn-round">{{translations.btnnolabel}}</button>
            </form>
          </div>
        </b-container>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      datasessionTime: null,
      idleDuration: 2,
      _st: null
    };
  },
  props: {
    redirect: {
      type: String
    },
    endpoint: {
      type: String
    },
    sessionTime: {
      type: Number,
      default: 2
    },
    translations: {
      type: Object,
      required: true,
      default: {
        btnyeslabel: "Yes",
        btnnolabel: "No",
        heading: "",
        subheading: ""
      }
    }
  },
  created(){
  this.datasessionTime = this.sessionTime;
  },
  mounted() {
    this.startTimer(this.datasessionTime);
    // Modal States - shown or hidden
    this.$root.$on('bv::modal::shown', (bvEvent) => {
      if(bvEvent.vueTarget.$options.propsData.id === 'ahaTimeoutModal') {
          this.onIdle("active");
      }
    }) 
  },
  methods: {
    handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaTimeoutModal");
    },
    onSubmit() {
      axios.get(this.$props.endpoint).then(response => {
        if(response.status ===  200){
          this.onIdle("reset");
          this.datasessionTime = this.sessionTime;
          this.startTimer(this.datasessionTime);
          this.handleClose();
        }
      });
    },
    onCancel() {
		this.datasessionTime = 0;
		if(this.$props.redirect){
            window.location.href = this.$props.redirect;
		} else {
            this.logOut();
		}	  
        this.handleClose();
    },
    onIdle(state) {
        state = state || "active"; // 'active' or 'reset'
        
        let _duration = Number(this.idleDuration) * 60 * 1000;
        // var _st = null;
        
        if(state === "reset") {
            clearTimeout(this._st)
            this._st = null;
        } else {
            this._st = setTimeout(() => {
                this.onCancel();
            }, _duration);
        }
    },
    logOut() {
        if(typeof window.GenerateLogoutRequest !== 'undefined'){
            window.GenerateLogoutRequest();
        } else {
            return;
        }
    },
    showModal() {
      this.$root.$emit("bv::show::modal", "ahaTimeoutModal");
    },
    startTimer: function(duration) {
      if(duration !== 0){
        const vm = this;
        let _duration = duration * 60;
        let timer = _duration, minutes, seconds;

        let countdown =  setInterval(function () {
              minutes = Number(timer / 60, 10);
              seconds = Number(timer % 60, 10);

              minutes = minutes < 10 ? "0" + minutes : minutes;
              seconds = seconds < 10 ? "0" + seconds : seconds;

              if ( timer == 0) {
                  timer = 0;
                  //clearTimer(countdown);
                  clearInterval(countdown);
                  vm.showModal();
              } else {
                --timer;
              }
          }, 1000);
      } else {
          return;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-session-timeout-modal.vue